import m from "mithril"
import Kindle from "../shared/kindle.js"
import AgendaRootContainer from "./agenda-view.js"
import "../shared/base.css"
import "../shared/standalone.css"
import "../shared/util.js"

// Kindle.isKindle = true;
Kindle.debug = true;
Kindle.init(true);


document.redraw = function(flashNow) {
  m.redraw();
  Kindle.refreshScreen(flashNow);
}

document.title = "Tasks"
document.addEventListener("DOMContentLoaded", function() {
  AgendaRootContainer.standalone = true;
  m.mount(document.body, AgendaRootContainer)
});
